// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"f2ef0a12","289":"40403fba","297":"6ccf4987","427":"832bbf64","472":"7957a47f","527":"ab4ca9a2","598":"14589c73","701":"fa17acc5","710":"1676668f","787":"a2c1a5aa","830":"f04bb6ec","850":"c5958f49","904":"6b346779"}[chunkId] + ".chunk.js";
};